import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Download, FileSpreadsheet, Printer } from 'lucide-react';
import { useEmpExport } from '@/hooks/useEmpExport';

interface EmpExportButtonProps {
  /** Data rows for Excel export */
  getData: () => Record<string, unknown>[];
  /** Multiple sheets for Excel export */
  getSheets?: () => Array<{ name: string; data: Record<string, unknown>[] }>;
  /** Filename without extension */
  filename: string;
  /** PDF print title */
  printTitle?: string;
  /** Optional extra menu items rendered before default ones */
  extraItems?: Array<{ label: string; icon: React.ElementType; onClick: () => void; disabled?: boolean }>;
}

export const EmpExportButton: React.FC<EmpExportButtonProps> = ({
  getData,
  getSheets,
  filename,
  printTitle,
  extraItems,
}) => {
  const { exportToExcel, exportMultiSheet, exportToPDF } = useEmpExport();

  const handleExcel = () => {
    if (getSheets) {
      exportMultiSheet(getSheets(), filename);
    } else {
      exportToExcel(getData(), filename);
    }
  };

  const handlePDF = () => {
    exportToPDF(printTitle || filename);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Download className="h-4 w-4 mr-1" /> Exportar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {extraItems?.map((item, i) => (
          <DropdownMenuItem key={i} onClick={item.onClick} disabled={item.disabled}>
            <item.icon className="h-4 w-4 mr-2" /> {item.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem onClick={handleExcel}>
          <FileSpreadsheet className="h-4 w-4 mr-2" /> Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handlePDF}>
          <Printer className="h-4 w-4 mr-2" /> PDF (Imprimir)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
